"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
exports.__esModule = true;
var angular = require("angular");
var waterfall_chart_1 = require("./waterfall.chart");
var basic_chart_component_1 = require("../basic-component/basic-chart.component");
var WaterfallComponent = /** @class */ (function (_super) {
    __extends(WaterfallComponent, _super);
    function WaterfallComponent($scope, $timeout) {
        var _this = 
        // This constructor is necessary for inject scope and timeout.
        _super.call(this, $scope, $timeout, 'Waterfall') || this;
        var ctrl = _this;
        $scope.$on('command:WATERFALL', function (event, args) { return ctrl.initComponent(event, args); });
        return _this;
    }
    WaterfallComponent.prototype.getChartOptions = function (graph, options) {
        return waterfall_chart_1.getChartOptions(graph, options);
    };
    WaterfallComponent.prototype.exportCsv = function (csvFormat) {
        if (csvFormat === void 0) { csvFormat = ''; }
        var ctrl = this;
        var filename = this.filename();
        var csv = generateCsv(ctrl.selectedGraph, csvFormat, { main: this.currentNode.name, sibling: this.siblingNode ? this.siblingNode.name : "" });
        var blob = new Blob([csv], { type: "text/plain;charset=utf-8" });
        saveAs(blob, filename);
        function generateCsv(graphData, csvFormat, nodeName) {
            var mainRows = graphData.mainRows, siblingRows = graphData.siblingRows, differenceRows = graphData.differenceRows, isCompareTo = graphData.isCompareTo, yTitle = graphData.yTitle;
            if (!differenceRows && !mainRows) {
                return '';
            }
            var cellSeparator = csvFormat === 'EU' ? ';' : ',';
            var decimalPoint = csvFormat === 'EU' ? ',' : '.';
            var lines = [];
            if (isCompareTo && differenceRows) {
                // Difference Table
                lines.push(differenceRows.map(function (row) { return formatCell(row['label'], decimalPoint); }).join(cellSeparator));
                lines.push(differenceRows.map(function (row) { return formatCell(row['value'], decimalPoint); }).join(cellSeparator));
                lines.push("");
            }
            // Attributes Table (main and sibling
            if (mainRows && mainRows.length > 0) {
                var header = [""];
                if (isCompareTo) {
                    header.push(formatCell(("Incremental " + yTitle + " - " + nodeName.main), decimalPoint));
                    header.push(formatCell(("Incremental " + yTitle + " - " + nodeName.sibling), decimalPoint));
                }
                else {
                    header.push(formatCell(("Incremental " + yTitle), decimalPoint));
                }
                lines.push(header.join(cellSeparator));
                mainRows.forEach(function (row, idx) {
                    var curr = [formatCell(row['label'], decimalPoint), formatCell(row['value'], decimalPoint)];
                    if (isCompareTo && siblingRows) {
                        curr.push(formatCell(siblingRows[idx]['value'], decimalPoint));
                    }
                    lines.push(curr.join(cellSeparator));
                });
            }
            return lines.join('\n');
        }
        function formatCell(val, decimalPoint) {
            if (typeof val === 'undefined' || val === null) {
                return '""';
            }
            var str = val.toString().trim();
            if (!isNaN(val)) {
                return str.replace('.', decimalPoint);
            }
            return "\"" + str + "\"";
        }
    };
    WaterfallComponent = __decorate([
        basic_chart_component_1.Component({
            bindings: {
                menu: '='
            },
            template: require("./waterfall.component.html")
        }),
        __metadata("design:paramtypes", [Object, Object])
    ], WaterfallComponent);
    return WaterfallComponent;
}(basic_chart_component_1.BasicChartComponent));
exports.WaterfallComponent = WaterfallComponent;
angular.module('smartorg.r6.acts.waterfall', []).filter('textOrNumber', ['$filter', function ($filter) {
        return function (input, fractionSize) {
            if (isNaN(input) || (fractionSize == "Default")) {
                return input;
            }
            else {
                return $filter('number')(input, fractionSize);
            }
        };
    }]).component('waterfall', WaterfallComponent);
module.exports = 'smartorg.r6.acts.waterfall';
//# sourceMappingURL=waterfall.component.js.map


// WEBPACK FOOTER //
// ./app/widgets/action/waterfall2/waterfall.component.js